export default "a-default2";



// WEBPACK FOOTER //
// ./src/mod5.js